export type HashtaggingMode = 'at_least_one_hashtag' | 'optional' | 'at_least_one_company_hashtag';

enum CatalogState {
	Active = 'active',
	Paused = 'paused',
	Shutoff = 'shutoff',
}

export enum CompanyStatus {
	InTrial = 'in_trial',
	Active = 'active',
	NonRenewing = 'non_renewing',
}

export default interface Company {
	axomo_subdomain?: string;
	bonus_privacy: boolean;
	budget: Budget;
	catalog_state: CatalogState;
	company_hashtags: string[];
	created_at: string;
	disable_gifs: boolean;
	disable_image_uploads: boolean;
	disable_video_recordings: boolean;
	disable_video_uploads: boolean;
	example_reason: string;
	give_amounts: number[];
	has_claimable_awards: boolean;
	hashtagging_mode: HashtaggingMode;
	hide_competitive_features: boolean;
	monarch_cohort: string;
	id: string;
	logo_url: string;
	name: string;
	show_bonus_amounts: boolean;
	status: CompanyStatus;
	sign_up_company_size: number;
	subscription_days_past_due: number;
	suggested_hashtags: string[];
	zero_point_bonuses: boolean;
	trial_end_date: string;
	product_tier: string;
}

export type CompanyGiveBoxProps = Pick<Company, 'budget' | 'give_amounts' | 'id' | 'example_reason' | 'hashtagging_mode' | 'company_hashtags'>;

export interface Budget {
	display_unit: string;
	exchange_rate: number;
	format: CurrencyFormat;
	plural: string;
	singular: string;
	id: string;
}

export interface CurrencyFormat {
	plural: string;
	singular: string;
}

export interface CompanyProfile {
	id: string;
	budget: Budget;
	created_at: string;
	has_claimable_awards: boolean;
	hide_competitive_features: boolean;
	logo_url: string;
	monarch_cohort: string;
	name: string;
	status: string;
	trial_end_date: string;
	updated_at: string;
}
